let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9HBRJ")).then(() => parcelRequire('aRJm6'));